import * as React from 'react';
import './profileChangePane.module.scss';
import { observer, inject } from 'mobx-react';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { observable, makeObservable } from 'mobx';
import { FormInput } from '../../atoms/forms/FormInput';
import { ProfileChangePaneState } from './states/ProfileChangePaneState';
import { GlobalLoader } from '../../../../mainv2/components/GlobalLoader';
import { NotFoundPage } from '../../../../mainv2/containers/common/NotFoundPage';
import DefaultUserProfile from './default-user-profile.png';
import { SettingPane } from '../../molecules/mypage/page';
import { Button } from '@sheinc/shelikes-design-system';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

type Props = {
  homeState: HomePageState;
};

export const ProfileChangePane = inject('homeState')(
  observer(
    class ProfileChangePane extends React.Component<Props> {
      pageState = new ProfileChangePaneState();

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          pageState: observable,
        });
      }

      componentDidMount(): void {
        this.pageState.init();
      }

      render() {
        const { submitting, formState, currentProfile, newProfileUrl } = this.pageState;
        if (currentProfile.loading) {
          return <GlobalLoader />;
        }
        if (currentProfile.isNotFound()) {
          return <NotFoundPage />;
        }
        const profileSrc = newProfileUrl || currentProfile.getOrThrow().profile_url;
        return (
          <SettingPane activeMenu="profile" title="プロフィールを編集">
            <div styleName="form-group">
              <img src={profileSrc || DefaultUserProfile} styleName={'profile-image'} />
              <div styleName="image-form-input-wrapper">
                <label styleName="image-form-input">
                  写真を変更する
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => this.pageState.setProfileImage(e.target.files)}
                  />
                </label>
              </div>
            </div>
            <div styleName="form-group">
              <div styleName="form-label">名前</div>
              <FormInput
                styleName="name"
                name="name"
                value={formState.getValue('name')}
                placeholder=""
                onChange={(e) => formState.setValue('name', e.target.value)}
                error={formState.getError('name')}
              />
            </div>
            <div styleName="form-group">
              <div styleName="form-label">フリガナ</div>
              <FormInput
                styleName="furigana"
                name="furigana"
                value={formState.getValue('furigana')}
                placeholder=""
                onChange={(e) => formState.setValue('furigana', e.target.value)}
                error={formState.getError('furigana')}
              />
            </div>
            <div styleName="form-group">
              <div styleName="form-label">年齢</div>
              <FormInput
                styleName="age"
                name="age"
                value={formState.getValue('age')}
                placeholder=""
                onChange={(e) => formState.setValue('age', e.target.value)}
                error={formState.getError('age')}
              />
            </div>
            <div styleName="form-group">
              <div styleName="form-label">会社名</div>
              <FormInput
                styleName="job-company"
                name="job_company"
                value={formState.getValue('job_company')}
                placeholder=""
                onChange={(e) => formState.setValue('job_company', e.target.value)}
                error={formState.getError('job_company')}
              />
            </div>
            <div styleName="form-group">
              <div styleName="form-label">部署</div>
              <FormInput
                styleName="job-department"
                name="job_department"
                value={formState.getValue('job_department')}
                placeholder=""
                onChange={(e) => formState.setValue('job_department', e.target.value)}
                error={formState.getError('job_department')}
              />
            </div>
            <div styleName="form-group">
              <div styleName="form-label">職種</div>
              <FormInput
                styleName="job-title"
                name="job_title"
                value={formState.getValue('job_title')}
                placeholder=""
                onChange={(e) => formState.setValue('job_title', e.target.value)}
                error={formState.getError('job_title')}
              />
            </div>
            <div styleName="form-submit-button">
              <Button
                isLoading={submitting}
                onClick={() => this.pageState.submit()}
                fullWidth={GlobalStatesV3.viewport.isSp}
              >
                保存する
              </Button>
            </div>
          </SettingPane>
        );
      }
    }
  )
);
